
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { APP_NAME } from "@/lib/constants";

export const faqs = [
  {
    question: `Is ${APP_NAME} really free?`,
    answer: `Yes! Our free plan includes unlimited bookings, one staff member, online booking pages, email reminders, and more. No credit card required to get started. We also offer paid plans with advanced features like analytics, integrations, and multi-staff support.`,
  },
  {
    question: `What types of businesses can use ${APP_NAME}?`,
    answer: `${APP_NAME} works for any appointment-based business — salons, barbershops, clinics, therapists, tutors, consultants, personal trainers, photographers, tradespeople, and more. If you take bookings, we've got you covered.`,
  },
  {
    question: "How do automated reminders work?",
    answer:
      "We send automatic email reminders to your customers before their appointments. This helps reduce no-shows by up to 70%. Premium plans also support SMS and WhatsApp reminders for even higher engagement.",
  },
  {
    question: "Can my customers book online 24/7?",
    answer:
      "Absolutely. Every business gets a customisable online booking page where customers can see your availability, choose a service and staff member, and book instantly — day or night, from any device.",
  },
  {
    question: "Does it work on mobile?",
    answer: `Yes! ${APP_NAME} is fully responsive and works beautifully on phones, tablets, and desktops. We also offer a branded Progressive Web App (PWA) so your customers can install your booking page like a native app.`,
  },
  {
    question: "Can I accept online payments?",
    answer:
      "Yes. Connect your Stripe account to accept deposits or full payments at the time of booking. You can also choose to allow pay-at-shop for in-person payments.",
  },
  {
    question: "How do I manage multiple staff members?",
    answer:
      "Our Basic and Premium plans support multiple staff profiles, each with their own availability, services, and calendar. Staff can log in to view their schedules, manage bookings, and track timecards.",
  },
  {
    question: "Is my data secure and GDPR compliant?",
    answer: `Absolutely. ${APP_NAME} is built with security and privacy at its core. We are fully GDPR compliant, store data securely in the EU, and give you tools to manage customer consent and data retention.`,
  },
];

export function FAQSection() {
  return (
    <section className="container px-4 py-20">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-foreground">
          Frequently Asked Questions
        </h2>
        <p className="text-center text-muted-foreground mb-10">
          Everything you need to know about {APP_NAME}.
        </p>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`faq-${index}`}>
              <AccordionTrigger className="text-left text-foreground">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
